import React from 'react';
import MUIIconButton, {
  IconButtonProps as MUIIconButtonProperties,
} from '@mui/material/IconButton';

type IconButtonProperties = MUIIconButtonProperties & {
  /** Alias for `aria-label` */
  ariaLabel?: string;
};

const IconButton = ({
  ariaLabel = 'icon', color = 'primary', size = 'small', ...properties
}: IconButtonProperties) => (
  <MUIIconButton
    aria-label={ariaLabel}
    color={color}
    size={size}
    {...properties}
  />
);

export default IconButton;
